import { useEffect } from "react";

export function useDragToScroll(tableRef) {
  useEffect(() => {
    const tableBody = tableRef.current?.querySelector(".ant-table-body");
    if (!tableBody) return;

    let isDown = false;
    let startX;
    let scrollLeft;

    const handleMouseDown = (e) => {
      isDown = true;
      tableBody.classList.add("dragging");
      startX = e.pageX - tableBody.offsetLeft;
      scrollLeft = tableBody.scrollLeft;
    };

    const handleMouseLeave = () => {
      isDown = false;
      tableBody.classList.remove("dragging");
    };

    const handleMouseUp = () => {
      isDown = false;
      tableBody.classList.remove("dragging");
    };

    const handleMouseMove = (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - tableBody.offsetLeft;
      const walk = (x - startX) * 1; // Adjust multiplier for speed
      tableBody.scrollLeft = scrollLeft - walk;
    };

    tableBody.addEventListener("mousedown", handleMouseDown);
    tableBody.addEventListener("mouseleave", handleMouseLeave);
    tableBody.addEventListener("mouseup", handleMouseUp);
    tableBody.addEventListener("mousemove", handleMouseMove);

    return () => {
      tableBody.removeEventListener("mousedown", handleMouseDown);
      tableBody.removeEventListener("mouseleave", handleMouseLeave);
      tableBody.removeEventListener("mouseup", handleMouseUp);
      tableBody.removeEventListener("mousemove", handleMouseMove);
    };
  }, [tableRef]);
}
